import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withKeys as _withKeys, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "p-d-flex p-jc-between p-flex-column p-flex-sm-row" }
const _hoisted_3 = { class: "toolbar_left" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Nessun elemento trovato. ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Caricamento in corso... ")
const _hoisted_6 = { class: "p-d-flex p-jc-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageHeader = _resolveComponent("PageHeader")!
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Column = _resolveComponent("Column")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_EntityPickerDialog = _resolveComponent("EntityPickerDialog")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageHeader, {
      title: _ctx.$t('customer.pickers_title'),
      showDelete: false,
      showSave: false
    }, null, 8, ["title"]),
    _createVNode(_component_DataTable, {
      ref: "dt",
      value: _ctx.pickers,
      dataKey: "id",
      lazy: true,
      loading: _ctx.requestPending,
      totalRecords: _ctx.totalRecords,
      rows: 10,
      "rows-per-page-options": [10, 20, 50, 100],
      paginator: true,
      "auto-layout": "",
      "striped-rows": "",
      responsiveLayout: "scroll",
      filterDisplay: "row",
      filters: _ctx.filters,
      "onUpdate:filters": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filters = $event)),
      stateStorage: "session",
      showFilterOperator: false,
      onPage: _ctx.onPage,
      onSort: _ctx.onSort
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_Button, {
              type: "button",
              icon: "pi pi-filter-slash",
              label: "Reset",
              class: "p-button-outlined",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.clearFilters()))
            })
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_Button, {
              icon: "pi pi-plus",
              label: "Aggiungi",
              onClick: _ctx.showNewPicker
            }, null, 8, ["onClick"])
          ])
        ])
      ]),
      empty: _withCtx(() => [
        _hoisted_4
      ]),
      loading: _withCtx(() => [
        _hoisted_5
      ]),
      default: _withCtx(() => [
        _createVNode(_component_Column, {
          field: "name",
          header: "Name",
          sortable: true,
          showFilterMatchModes: false,
          showFilterMenu: false,
          style: {"min-width":"130px"}
        }, {
          filter: _withCtx(({filterModel,filterCallback}) => [
            _withDirectives(_createVNode(_component_InputText, {
              type: "text",
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => (filterModel.value = $event),
              onKeydown: _withKeys(($event: any) => (_ctx.onApplyFilter(filterCallback)), ["enter"]),
              class: "p-column-filter",
              placeholder: `nome`
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeydown"]), [
              [
                _directive_tooltip,
                'Conferma premendo enter',
                void 0,
                {
                  top: true,
                  focus: true
                }
              ]
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "type",
          header: "Tipo",
          showFilterMatchModes: false,
          showFilterMenu: false
        }, {
          body: _withCtx(({data}) => [
            _createElementVNode("div", {
              class: _normalizeClass(["picker-type-badge", {
                'pickup': data.type === 10,
                'dropoff': data.type === 20
              }])
            }, _toDisplayString(data.type === 20 ? 'CONSEGNA' : 'RITIRO'), 3)
          ]),
          filter: _withCtx(({filterModel,filterCallback}) => [
            _createVNode(_component_Dropdown, {
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => (filterModel.value = $event),
              onChange: ($event: any) => (_ctx.onApplyFilter(filterCallback)),
              class: "p-column-filter",
              placeholder: `tipo`,
              options: _ctx.typeOptions,
              optionLabel: "label",
              optionValue: "value",
              showClear: ""
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange", "options"])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "address",
          header: "Indirizzo",
          showFilterMatchModes: false,
          showFilterMenu: false,
          style: {"min-width":"200px"}
        }, {
          filter: _withCtx(({filterModel,filterCallback}) => [
            _withDirectives(_createVNode(_component_InputText, {
              type: "text",
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => (filterModel.value = $event),
              onKeydown: _withKeys(($event: any) => (_ctx.onApplyFilter(filterCallback)), ["enter"]),
              class: "p-column-filter",
              placeholder: `indirizzo`
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeydown"]), [
              [
                _directive_tooltip,
                'Conferma premendo enter',
                void 0,
                {
                  top: true,
                  focus: true
                }
              ]
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "city_name",
          header: "Città"
        }),
        _createVNode(_component_Column, {
          field: "province",
          header: "Provincia"
        }),
        _createVNode(_component_Column, {
          field: "note",
          header: "Note"
        }),
        _createVNode(_component_Column, null, {
          body: _withCtx(({data}) => [
            _createElementVNode("div", _hoisted_6, [
              _withDirectives(_createVNode(_component_Button, {
                icon: "pi pi-pencil",
                class: "p-mr-1 p-button-warning",
                onClick: ($event: any) => (_ctx.onEditPicker(data))
              }, null, 8, ["onClick"]), [
                [
                  _directive_tooltip,
                  _ctx.$t('edit'),
                  void 0,
                  { bottom: true }
                ]
              ]),
              _withDirectives(_createVNode(_component_Button, {
                icon: "pi pi-times",
                class: "p-button-danger",
                onClick: ($event: any) => (_ctx.onDeletePicker(data))
              }, null, 8, ["onClick"]), [
                [
                  _directive_tooltip,
                  _ctx.$t('remove'),
                  void 0,
                  { bottom: true }
                ]
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["value", "loading", "totalRecords", "filters", "onPage", "onSort"]),
    (_ctx.me?.entity_id)
      ? (_openBlock(), _createBlock(_component_EntityPickerDialog, {
          key: 0,
          entityId: _ctx.me.entity_id,
          initialValue: _ctx.editPicker,
          visible: _ctx.displayNewPicker,
          "onUpdate:visible": [
            _cache[2] || (_cache[2] = ($event: any) => (_ctx.displayNewPicker = $event)),
            _ctx.onUpdateVisible
          ],
          onSaved: _ctx.onSaved
        }, null, 8, ["entityId", "initialValue", "visible", "onUpdate:visible", "onSaved"]))
      : _createCommentVNode("", true)
  ]))
}